<template lang="pug">
.efight-mainmarket-group.mario.mt-2
  .efight-mainmarket-item(
    v-if="source != null"
    type='button' 
    :id="source.items[0].id"
    :class="{ 'collapsed': source.items[0].marketId != 3 }"
    :data-toggle="source.items[0].marketId == 3 ? '' : 'collapse'"
    :data-target="source.items[0].marketId == 3 ? '' : '#mainmarket-' + source.items[0].matchId"
  )
    .row.mainmarket-item-top
      efTimer(:source="source.items[0]" :horiz="false" :class="{ 'd-none' : source.items[0].marketId == 3 }")
      .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
        img.live-icon(src='images/egame/live-icon.svg')
        span.mx-1 LIVE
        .live-dot
    .mainmarket-item-match
      .team1
        img.characters(:src="getImage(source.items[0].sportsId, source.items[7].matchBody[22])")
        img.characters(:src="getImage(source.items[0].sportsId, source.items[6].matchBody[22])")
        span.name {{ source.items[0].homeTeam }}
      .vs
        img.img-fluid(src='images/egame/vs.svg')
      .team2
        img.characters(:src="getImage(source.items[0].sportsId, source.items[8].matchBody[23])")
        img.characters(:src="getImage(source.items[0].sportsId, source.items[9].matchBody[23])")
        span.name {{ source.items[0].awayTeam }}
  .collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'mainmarket-' + source.items[0].matchId"
  )
    .match-collapse-body
      .efight-marketgroup-content
        .row.justify-content-center.m-0.mt-2
          .col-6.efight-odds-group
            .efight-odds.d-block  <!-- Team Win -->
              .bettype-col {{ $t("m.MA_ML_TW") }}
              template(v-if="checkBool(source, 0, 'ml', 0, 5)")
                OddsItem(:odds="source.items[0].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled               
            .row.m-0
              .efight-odds.d-block  <!-- 3-0 -->
                .bettype-col {{ $t("m.MA_CS_3_0") }}
                template(v-if="checkBool(source, 0, 'cs', 3, 5)")
                  OddsItem(:odds="source.items[0].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block  <!-- 2-1 -->
                .bettype-col {{ $t("m.MA_CS_2_1") }}
                template(v-if="checkBool(source, 0, 'cs', 2, 5)")                  
                  OddsItem(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled          
            .row.m-0
              .efight-odds.d-block   <!-- Round 1 Winner -->
                .bettype-col {{ $t("m.MA_R_1_W") }}    
                template(v-if="checkBool(source, 10, 'ml', 0, 5)")
                  OddsItem(:odds="source.items[10].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled          
            .row.m-0
              .efight-odds.d-block  <!-- Round 2 Winner -->
                .bettype-col {{ $t("m.MA_R_2_W") }}    
                template(v-if="checkBool(source, 11, 'ml', 0, 5)")
                  OddsItem(:odds="source.items[11].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled                                
            .row.m-0       
              .efight-odds.d-block  <!-- Round 3 Winner -->
                .bettype-col {{ $t("m.MA_R_3_W") }}    
                template(v-if="checkBool(source, 12, 'ml', 0, 5)")
                  OddsItem(:odds="source.items[12].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled             
            .row.m-0
              .efight-odds.d-block  <!-- Over -->
                .bettype-col {{ `${$t("m.MA_O") }(22.5)` }} 
                template(v-if="checkBool(source, 1, 'ou', 0, 12)")     
                  OddsItem(:odds="source.items[1].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[1].details" homeAway="1")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block  <!-- Under -->
                .bettype-col {{ `${$t("m.MA_U") }(22.5)` }}
                template(v-if="checkBool(source, 1, 'ou', 0, 11)")     
                  OddsItem(:odds="source.items[1].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[1].details" homeAway="1")
                template(v-else)
                  OddsDisabled         
            .row.m-0
              .efight-odds.d-block  <!-- Odd -->
                .bettype-col {{ $t("m.MA_OE1") }}
                template(v-if="checkBool(source, 1, 'oe', 0, 5)")     
                  OddsItem(:odds="source.items[1].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block  <!-- Even -->
                .bettype-col {{ $t("m.MA_OE2") }}
                template(v-if="checkBool(source, 1, 'oe', 0, 7)")     
                  OddsItem(:odds="source.items[1].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
                template(v-else)
                  OddsDisabled
          .col-6.efight-odds-group
            .efight-odds.d-block  <!-- Team Win -->
              .bettype-col {{ $t("m.MA_ML_TW") }}
              template(v-if="checkBool(source, 0, 'ml', 0, 7)")     
                OddsItem(:odds="source.items[0].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled                
            .row.m-0
              .efight-odds.d-block  <!-- 1-2 -->
                .bettype-col {{ $t("m.MA_CS_1_2") }}
                template(v-if="checkBool(source, 0, 'cs', 1, 5)")   
                  OddsItem(:odds="source.items[0].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" )
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block  <!-- 0-3 -->
                .bettype-col {{ $t("m.MA_CS_0_3") }}
                template(v-if="checkBool(source, 0, 'cs', 0, 5)")   
                  OddsItem(:odds="source.items[0].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                template(v-else)
                  OddsDisabled      
            .row.m-0
              .efight-odds.d-block  <!-- Round 1 Winner -->
                .bettype-col {{ $t("m.MA_R_1_W") }}    
                template(v-if="checkBool(source, 10, 'ml', 0, 7)")
                  OddsItem(:odds="source.items[10].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled     
            .row.m-0  
              .efight-odds.d-block  <!-- Round 2 Winner -->
                .bettype-col {{ $t("m.MA_R_2_W") }}    
                template(v-if="checkBool(source, 11, 'ml', 0, 7)")
                  OddsItem(:odds="source.items[11].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled     
            .row.m-0    
              .efight-odds.d-block  <!-- Round 3 Winner -->
                .bettype-col {{ $t("m.MA_R_3_W") }}    
                template(v-if="checkBool(source, 12, 'ml', 0, 7)")
                  OddsItem(:odds="source.items[12].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                template(v-else)
                  OddsDisabled          
            .row.m-0
              .efight-odds.d-block  <!-- Under -->
                .bettype-col {{ $t("m.MA_U") }}(22.5)
                template(v-if="checkBool(source, 2, 'ou', 0, 12)")   
                  OddsItem(:odds="source.items[2].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[2].details" homeAway="2")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block  <!-- Over -->
                .bettype-col {{ $t("m.MA_O") }}(22.5)
                template(v-if="checkBool(source, 2, 'ou', 0, 11)")   
                  OddsItem(:odds="source.items[2].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[2].details" homeAway="2")
                template(v-else)
                  OddsDisabled       
            .row.m-0
              .efight-odds.d-block  <!-- Even -->
                .bettype-col {{ $t("m.MA_OE2") }}
                template(v-if="checkBool(source, 2, 'oe', 0, 7)")     
                  OddsItem(:odds="source.items[2].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
                template(v-else)
                  OddsDisabled
              .efight-odds.d-block  <!-- Odd -->
                .bettype-col {{ $t("m.MA_OE1") }}
                template(v-if="checkBool(source, 2, 'oe', 0, 5)")     
                  OddsItem(:odds="source.items[2].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
                template(v-else)
                  OddsDisabled   
          .col-12.efight-odds-group.mt-3      
            .row.m-0
              .col-6.efight-odds-group
                .mainmarket-item-match.row.mario-team
                  .team1.mario-sub
                    img.characters(:src="getImage(source.items[0].sportsId, source.items[6].matchBody[22])")
                    span.name {{ source.items[6].homeTeam }}
              .col-6.efight-odds-group
                .mainmarket-item-match.row.mario-team
                  .team1.mario-sub
                    img.characters(:src="getImage(source.items[0].sportsId, source.items[7].matchBody[22])")
                    span.name {{ source.items[7].homeTeam }}
          .col-12.efight-odds-group 
            .row.m-0
              .col-6.efight-odds-group.pt-2
                .efight-odds.d-block  <!-- Round 1 Winner - P1 -->
                  .bettype-col {{ $t("m.MA_R_1_W") }}
                  template(v-if="checkBool(source, 3, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[3].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
                .efight-odds.d-block  <!-- Round 2 Winner - P1 -->
                  .bettype-col {{ $t("m.MA_R_2_W") }}
                  template(v-if="checkBool(source, 4, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[4].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
                .efight-odds.d-block  <!-- Round 3 Winner - P1 -->
                  .bettype-col {{ $t("m.MA_R_3_W") }}
                  template(v-if="checkBool(source, 5, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[5].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .col-6.efight-odds-group.pt-2
                .efight-odds.d-block <!-- Round 1 Winner - P2 -->
                  .bettype-col {{ $t("m.MA_R_1_W") }}
                  template(v-if="checkBool(source, 3, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[3].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled              
                .efight-odds.d-block <!-- Round 2 Winner - P2 -->
                  .bettype-col {{ $t("m.MA_R_2_W") }}
                  template(v-if="checkBool(source, 4, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[4].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled             
                .efight-odds.d-block <!-- Round 3 Winner - P2 -->
                  .bettype-col {{ $t("m.MA_R_3_W") }}
                  template(v-if="checkBool(source, 5, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[5].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled    
          .col-12.efight-odds-group.mt-3      
            .row.m-0
              .col-6.efight-odds-group
                .mainmarket-item-match.row.mario-team
                  .team2.mario-sub
                    img.characters(:src="getImage(source.items[0].sportsId, source.items[8].matchBody[23])")
                    span.name {{ source.items[8].awayTeam }}
              .col-6.efight-odds-group
                .mainmarket-item-match.row.mario-team
                  .team2.mario-sub
                    img.characters(:src="getImage(source.items[0].sportsId, source.items[9].matchBody[23])")
                    span.name {{ source.items[9].awayTeam }}
          .col-12.efight-odds-group.border-bottom 
            .row.m-0
              .col-6.efight-odds-group.pt-2
                .efight-odds.d-block  <!-- Round 1 Winner - P3 -->
                  .bettype-col {{ $t("m.MA_R_1_W") }}
                  template(v-if="checkBool(source, 3, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[3].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
                .efight-odds.d-block  <!-- Round 2 Winner - P3 -->
                  .bettype-col {{ $t("m.MA_R_2_W") }}
                  template(v-if="checkBool(source, 4, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[4].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
                .efight-odds.d-block  <!-- Round 3 Winner - P3 -->
                  .bettype-col {{ $t("m.MA_R_3_W") }}
                  template(v-if="checkBool(source, 5, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[5].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
              .col-6.efight-odds-group.pt-2
                .efight-odds.d-block <!-- Round 1 Winner - P4 -->
                  .bettype-col {{ $t("m.MA_R_1_W") }}
                  template(v-if="checkBool(source, 3, 'cs', 3, 5)")
                    OddsItem(:odds="source.items[3].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled              
                .efight-odds.d-block <!-- Round 2 Winner - P4 -->
                  .bettype-col {{ $t("m.MA_R_2_W") }}
                  template(v-if="checkBool(source, 4, 'cs', 3, 5)")
                    OddsItem(:odds="source.items[4].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled             
                .efight-odds.d-block <!-- Round 3 Winner - P4 -->
                  .bettype-col {{ $t("m.MA_R_3_W") }}
                  template(v-if="checkBool(source, 5, 'cs', 3, 5)")
                    OddsItem(:odds="source.items[5].details['cs'][3]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled     
            
          .col-12.efight-odds-group 
            .row.m-0.mt-3
              .col-12.mb-3
                .font-weight-bolder.text-center.label-title {{ $t("m.MA_T_3_R") }} 
          
          .col-12.efight-odds-group
            .row.m-0.border-bottom
              .col-3.efight-odds-group.border-0
                .efight-odds.d-block  <!-- Any Win Rounds - P1 -->
                  .bettype-col {{ $t("m.MA_ANY_W_R") }}
                  template(v-if="checkBool(source, 6, 'ml', 0, 5)")
                    OddsItem(:odds="source.items[6].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled   
                .efight-odds.d-block  <!-- Any Win Rounds - P2 -->
                  template(v-if="checkBool(source, 7, 'ml', 0, 5)")
                    OddsItem(:odds="source.items[7].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled       
              .col-3.efight-odds-group.border-right 
                .efight-odds.d-block  <!-- No Win Rounds - P1 -->
                  .bettype-col {{ $t("m.MA_NO_W_R") }}
                  template(v-if="checkBool(source, 6, 'ml', 0, 7)")
                    OddsItem(:odds="source.items[6].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled  
                .efight-odds.d-block  <!-- No Win Rounds - P2 -->
                  template(v-if="checkBool(source, 7, 'ml', 0, 7)")
                    OddsItem(:odds="source.items[7].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled 
              .col-3.efight-odds-group.border-0
                .efight-odds.d-block  <!-- Any Win Rounds - P3 -->
                  .bettype-col {{ $t("m.MA_ANY_W_R") }}
                  template(v-if="checkBool(source, 8, 'ml', 0, 5)")
                    OddsItem(:odds="source.items[8].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled      
                .efight-odds.d-block  <!-- Any Win Rounds - P4 -->
                  template(v-if="checkBool(source, 9, 'ml', 0, 5)")
                    OddsItem(:odds="source.items[9].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled       
              .col-3.efight-odds-group
                .efight-odds.d-block  <!-- No Win Rounds - P3 -->
                  .bettype-col {{ $t("m.MA_NO_W_R") }}
                  template(v-if="checkBool(source, 8, 'ml', 0, 7)")
                    OddsItem(:odds="source.items[8].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled      
                .efight-odds.d-block  <!-- No Win Rounds - P4 -->
                  template(v-if="checkBool(source, 9, 'ml', 0, 7)")
                    OddsItem(:odds="source.items[9].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled      
          .col-12.efight-odds-group
            .row.m-0.border-bottom
              .col-2.efight-odds-group.border-0.pt-3 
                .efight-odds.d-block  <!-- Win 1 - P1 -->
                  .bettype-col {{ $t("m.MA_W_1") }}
                  template(v-if="checkBool(source, 6, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[6].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled       
                .efight-odds.d-block  <!-- Win 1 - P2 -->
                  template(v-if="checkBool(source, 7, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[7].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled                            
              .col-2.efight-odds-group.pt-3 
                .efight-odds.d-block  <!-- Win 2 - P1 -->
                  .bettype-col {{ $t("m.MA_W_2") }}
                  template(v-if="checkBool(source, 6, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[6].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled             
                .efight-odds.d-block  <!-- Win 2 - P2 -->
                  template(v-if="checkBool(source, 7, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[7].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled                      
              .col-2.efight-odds-group.border-right.pt-3 
                .efight-odds.d-block  <!-- Prefect - P1 -->
                  .bettype-col {{ $t("m.MA_PF") }}
                  template(v-if="checkBool(source, 6, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[6].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled   
                .efight-odds.d-block  <!-- Prefect - P2 -->
                  template(v-if="checkBool(source, 7, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[7].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled     
              .col-2.efight-odds-group.pt-3 
                .efight-odds.d-block  <!-- Win 1 - P3 -->
                  .bettype-col {{ $t("m.MA_W_1") }}
                  template(v-if="checkBool(source, 8, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[8].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled              
                .efight-odds.d-block  <!-- Win 1 - P4 -->
                  template(v-if="checkBool(source, 9, 'cs', 0, 5)")
                    OddsItem(:odds="source.items[9].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled                      
              .col-2.efight-odds-group.pt-3 
                .efight-odds.d-block  <!-- Win 2 - P3 -->
                  .bettype-col {{ $t("m.MA_W_2") }}
                  template(v-if="checkBool(source, 8, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[8].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled      
                .efight-odds.d-block  <!-- Win 2 - P4 -->
                  template(v-if="checkBool(source, 9, 'cs', 1, 5)")
                    OddsItem(:odds="source.items[9].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled   
              .col-2.efight-odds-group.pt-3 
                .efight-odds.d-block  <!-- Prefect - P3 -->
                  .bettype-col {{ $t("m.MA_PF") }}
                  template(v-if="checkBool(source, 8, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[8].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled              
                .efight-odds.d-block  <!-- Prefect - P4 -->
                  template(v-if="checkBool(source, 9, 'cs', 2, 5)")
                    OddsItem(:odds="source.items[9].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled        
</template>

<script>
import config from "@/config";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    racingList(){
      return config.racingList;
    },
    newFeatures() {
      return config.newFeatures
    }
  },
  methods: {
    team(player, pos, isTeam) {
      if(isTeam) {
        var n = player.homeTeam;
        return n;
      } else {
        var n = player.homeTeam.split(" - ")[pos];
        return n;
      }
    },
    getImage(s, img) {
      // return config.resourceImgUrl + "/ef/uat/" + s + "/" +img+ ".png";
      return config.resourceImgUrl + "/ef/" + (this.newFeatures ? 'uat/' : 'prod/') + s + "/" +img+ ".png";
    },
    checkBool(source,source_index, key, key_index, child){
      return source.items[source_index] && source.items[source_index].details[key] && 
      source.items[source_index].details[key][key_index] && source.items[source_index].details[key][key_index][child] != 0 && 
      source.items[source_index].details[key][key_index][child] != ''
    },
  }
};
</script>